import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Link, Route, Routes, useParams } from "react-router-dom";
import { Person } from "../classes/Person.js"
import { useNavigate } from "react-router-dom";
// import '../styles/PersonDetails.css';

function PersonDetails(args) {
    const currentAuthKey = document.cookie.split("; ").find((row) => row.startsWith("authKey="))?.split("=")[1]
    const navigate = useNavigate()
    const requestManager = args.requestManager

    useEffect(() => {
        if (typeof currentAuthKey === "undefined") {
            navigate("/login")
        } else if (typeof data.keyError !== "undefined") {
            if (data.keyError === "notAuthorized") {
                navigate("/")
            } else {
                navigate("/login")
            }
        }
    })

    const { personID } = useParams()
    const [data, setData] = useState([{}])

    if (typeof data.status !== "undefined" && typeof data.keyError === "undefined") {
        var consultant = new Person()
        consultant.initalize(data.consultantData)
        setTimeout(() => {
            const scrollToID = document.getElementById("scrollToID")

            if (scrollToID != null) {
                scrollToID.scrollIntoView()
            }
        }, 100)

    } else {
        requestManager.request("getPersonDetails", "POST", { personID: personID }).then(res => res.json()).then((response) => {
            setData(response)
        })
    }

    return (
        <div class="container">
            <div class="pt-5 pb-5 mb-5 text-center">
                {
                    (typeof data.status === "undefined" || typeof data.keyError !== "undefined") ?
                        (<h1 class="loading">Loading</h1>) :
                        (<div>
                            <h1 class="display-3 fw-bold pb-3">{consultant.name}</h1>
                            <div class="row justify-content-center text-center">
                                {
                                    (consultant.source == "Bullhorn") ?
                                        (<>
                                            <h5 class="col-1" style={{ width: "5%", padding: "0px" }}><a href={"https://bullhornstaffing.com/BullhornSTAFFING/openwindow.cfm?entity=Candidate&ID="+consultant.externalID} target="_blank">Bullhorn</a></h5>
                                            <h5 class="col-1 ms-5" style={{ width: "5%", padding: "0px" }}><a href={"https://www.linkedin.com/search/results/people/?firstName="+consultant.firstName+"&lastName="+consultant.lastName} target="_blank">LinkedIn</a></h5>
                                        </>) :
                                        (<>
                                            <h5 class="col-1" style={{ width: "5%", padding: "0px" }}><a href={"https://www.linkedin.com/search/results/people/?firstName="+consultant.firstName+"&lastName="+consultant.lastName} target="_blank">LinkedIn</a></h5>
                                        </>)
                                }
                            </div>
                            <div class="allign-items-center justify-content-center mt-3">
                                <div class="border border-5 border-dark mt-0 pt-0 p-3">
                                    <div dangerouslySetInnerHTML={{ __html: consultant.resume }} style={{ all: "initial" }}></div>
                                </div>
                            </div>
                        </div>)
                }
            </div>
        </div>

    )
}

export default PersonDetails